/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Jpc_Duration_ValInputs */

const es_cap_jpc_duration_val = /** @type {(inputs: Cap_Jpc_Duration_ValInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Día completo · 6 h`)
};

const gl_cap_jpc_duration_val = /** @type {(inputs: Cap_Jpc_Duration_ValInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Día completo · 6 h`)
};

const en_cap_jpc_duration_val = /** @type {(inputs: Cap_Jpc_Duration_ValInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full day · 6 h`)
};

/**
* | output |
* | --- |
* | "Full day · 6 h" |
*
* @param {Cap_Jpc_Duration_ValInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_jpc_duration_val = /** @type {((inputs?: Cap_Jpc_Duration_ValInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Jpc_Duration_ValInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_jpc_duration_val(inputs)
	if (locale === "en") return en_cap_jpc_duration_val(inputs)
	return es_cap_jpc_duration_val(inputs)
});